import React, {FC, useEffect, useState} from 'react';

import path_up from 'assets/images/closeSelectIcon.svg';
import path_down from 'assets/images/openSelectIcon.svg';
import ToggleButton from "components/Toggle/Toggle";
import {t} from "i18next";
import FormSelect, {ISelectOption} from "../../../../commons/Select/FormSelect";
import Number from "../../../../commons/Input/Number";
import {Rule} from "./OrderProcessingRules";
import {Filter, Warehouse} from "../../OrdersSettingsFormWrapper";
import FormMultiSelect from "../../../../commons/Select/FormMultiSelect";

interface DataSourceProps {
  data: Rule
  updateDataHandler: (index: number, payload: Rule|null) => void
  toggleIsDisclosed: (index: number) => void
  index: number
  label: string
  isDisclosed: boolean,
  connectedMarkets: string[],
  connectedWarehouses: Warehouse[],
}

export const Item: FC<DataSourceProps> = ({
  data,
  updateDataHandler,
  toggleIsDisclosed,
  index,
  label,
  isDisclosed,
  connectedMarkets,
  connectedWarehouses,
}) => {

  const onStatusChange = (isActive: boolean) => {
    data.isActive = isActive
  };

  const [isFirstRender, setIsFirstRender] = useState<boolean>(true);

  const [isAutoChangeToConfirmed, setIsAutoChangeToConfirmed] = useState<boolean>(false);
  const [isAutoChangeToShipping, setIsAutoChangeToShipping] = useState<boolean>(false);
  const [isAutoChangeToDelivery, setIsAutoChangeToDelivery] = useState<boolean>(false);
  const [autoCancellationIfOutOfStock, setAutoCancellationIfOutOfStock] = useState<string|null>('');
  const [minimalStock, setMinimalStock] = useState<number>(0);
  const [filter, setFilter] = useState<Filter>({});
  const [errors, setErrors] = useState({filter: ''});
  const [marketsOptions, setMarketsOptions] = useState<ISelectOption[]>([]);
  const [warehousesOptions, setWarehousesOptions] = useState<ISelectOption[]>([]);

  // @ts-ignore
  const fieldsWithErrors = Object.keys(errors).filter((k: string) => errors[k].length > 0)
  const isFormHasErrors = fieldsWithErrors.length > 0

  const autoCancellationIfOutOfStockOptions: ISelectOption[] = [
      {text: 'Не учитывать', value: ''},
      {text: 'Частично отменить', value: 'partial'},
      {text: 'Полностью отменить', value: 'full'},
      {text: 'Только уведомить', value: 'notify_only'},
  ]

  useEffect(() => {
    // @ts-ignore
    setMarketsOptions([{text: 'Все', value: 'all'}, ...connectedMarkets.map(m => {
      return {
        text: t<string>(m, {ns: "messages"}),
        value: m
      }
    })])

    console.log('connectedMarkets:', connectedMarkets)
  }, [connectedMarkets])

  useEffect(() => {
    // @ts-ignore
    setWarehousesOptions([{text: 'Все', value: 'all'}, ...connectedWarehouses.map((m) => {
      return {
        text: t<string>(m.name, {ns: "messages"}),
        value: m.id
      }
    })])

  }, [connectedWarehouses])

  useEffect(() => {
    setFilter(data.filter)
    setIsAutoChangeToConfirmed(data.isAutoChangeToConfirmed)
    setIsAutoChangeToShipping(data.isAutoChangeToShipping)
    setIsAutoChangeToDelivery(data.isAutoChangeToDelivery)
    setAutoCancellationIfOutOfStock(data.autoCancellationIfOutOfStock)
    setMinimalStock(data.minimalStock)
  }, [data])

  useEffect(() => {
    // console.log(`useEffect - isAutoChangeToConfirmed (${isAutoChangeToConfirmed})`)

    if (isFirstRender) {
      setIsFirstRender(false);
      return;
    }

    // Fill filters
    Object.keys(filter).forEach((t) => {
      if (filter[t].values.length > 0) {
        data.filter[t] = filter[t]
      } else {
        delete data.filter[t]
      }
    })
    if (Object.keys(data.filter).length === 0) {
      errors.filter = 'Необходимо установить фильтр'
    } else  {
      errors.filter = ''
    }

    // Fill
    data.isAutoChangeToConfirmed = isAutoChangeToConfirmed
    data.isAutoChangeToShipping = isAutoChangeToShipping
    data.isAutoChangeToDelivery = isAutoChangeToDelivery
    data.autoCancellationIfOutOfStock = autoCancellationIfOutOfStock
    data.minimalStock = parseInt((minimalStock || 0).toString())
    updateDataHandler(index, data)

    setErrors(errors)

    // console.log('updateDataSourceHandler', data, index)
  }, [isAutoChangeToConfirmed, isAutoChangeToShipping, isAutoChangeToDelivery, autoCancellationIfOutOfStock, minimalStock, filter])

  const filterChangeHandler = (type: string, values: (string|number)[]) => {
    setFilter({
      ...filter,
      [type]: {
        type: type,
        operator: "in",
        values: values
      }
    })
      // console.log(type, values)
  }

  const customInputClassName = 'border-[#E2E8F0] mb-1 px-3 py-2 rounded-md text-sm shadow-sm placeholder-slate-400  w-full focus:outline-none focus:border-sky-500 focus:ring-1 focus:ring-sky-500 disabled:bg-slate-50 disabled:text-slate-500 disabled:border-slate-200 disabled:shadow-none'

  return (
      <div
          className="border-[1.75px] p-2 mt-4 cursor-pointer rounded-[5px] select-none shadow-smooth"
      >
        <div className="flex max-h-11 rounded items-center justify-between" onClick={() => toggleIsDisclosed(index)}>
          <div className="flex items-center min-w-36">
            <div className="text-xs flex flex-row text-[#1E293B] font-medium  text-sm">
              {label}
            </div>
          </div>
          <div className="flex items-center">
            <ToggleButton
                name={index + "isActive"}
                toggleHandler={onStatusChange}
                isChecked={data.isActive}
            />
            <span className={`pl-2 pr-10 text-[#94A3B8] italic text-sm`}>Автоматически</span>
            <div>
              <div>
                <img src={isDisclosed ? path_up : path_down} alt={''}/>
              </div>
            </div>
          </div>

        </div>
        {isDisclosed && (
            <div className={'mt-4'}>

              <div className="mt-6">
                <div className={`text-black font-bold`}>Применять для заказов</div>
                <div className={`grid grid-cols-2 gap-2 mt-1`}>
                  <div>
                    <FormMultiSelect
                        placeholder={`Выбрать`}
                        id={index + "filter.channel"}
                        name={index + "filter.channel"}
                        values={filter.channel?.values}
                        label={t<string>("Маркетплейс", {ns: "messages"})}
                        changeHandler={values => filterChangeHandler("channel", values)}
                        customClassName={``}
                        customLabelClassName="text-sm"
                        validationError={false}
                        validationErrorDescription={''}
                        options={marketsOptions}
                        require={false}
                    ></FormMultiSelect>
                  </div>
                  <div>
                    <FormMultiSelect
                        placeholder={`Выбрать`}
                        id={index + "filter.warehouse"}
                        name={index + "filter.warehouse"}
                        values={filter.warehouse?.values}
                        label={t<string>("Склад", {ns: "messages"})}
                        changeHandler={values => filterChangeHandler("warehouse", values)}
                        customClassName={``}
                        customLabelClassName="text-sm"
                        validationError={false}
                        validationErrorDescription={''}
                        options={warehousesOptions}
                        require={false}
                    ></FormMultiSelect>
                  </div>
                </div>
                <div className={`text-xs text-left text-red-500`}>{errors.filter}</div>
              </div>

              <div className="mt-8">
                <div className={`text-black font-bold`}>Обработка исключений</div>

                <div>
                  <div className={`text-sm font-medium text-black mt-2`}>Нет в наличии, или</div>
                  <div className={`flex justify-between mt-1`}>
                    <div className={`w-1/2 pr-2`}>
                      <Number
                          id={index + "minimalStock"}
                          name={index + "minimalStock"}
                          min={0}
                          value={minimalStock}
                          label={t<string>("достигнут минимальный остаток", {ns: "messages"})}
                          changeHandler={event => setMinimalStock(event.target.value)}
                          customClassName={customInputClassName}
                          customLabelClassName="text-sm"
                          validationError={false}
                          validationErrorDescription={''}
                          require={false}
                      />
                    </div>
                    <div className={`w-1/2 pl-2`}>
                      <FormSelect
                          id={index + "autoCancellationIfOutOfStock"}
                          name={index + "autoCancellationIfOutOfStock"}
                          value={autoCancellationIfOutOfStock || ''}
                          label={t<string>("Тогда", {ns: "messages"})}
                          changeHandler={event => setAutoCancellationIfOutOfStock(event.target.value)}
                          customClassName={customInputClassName}
                          customLabelClassName="text-sm"
                          blurHandler={event => setAutoCancellationIfOutOfStock(event.target.value)}
                          validationError={false}
                          validationErrorDescription={''}
                          options={autoCancellationIfOutOfStockOptions}
                          require={false}
                      ></FormSelect>
                    </div>
                  </div>
                </div>

              </div>

              <div className="mt-8">
                <div className={`text-black font-bold`}>Смена статусов</div>
                <div className={`w-2/3 mt-2`}>
                  <div className={`flex justify-between`}>
                    <div className={`text-sm font-medium`}>"Новый" на "На сборке"</div>
                    <ToggleButton
                        name={index + "isAutoChangeToConfirmed"}
                        toggleHandler={(v) => setIsAutoChangeToConfirmed(v)}
                        isChecked={isAutoChangeToConfirmed}
                    />
                  </div>
                  <div className={`flex justify-between mt-2`}>
                    <div className={`text-sm font-medium`}>"На сборке" на "На отгрузке"</div>
                    <ToggleButton
                        name={index + "isAutoChangeToShipping"}
                        toggleHandler={(v) => setIsAutoChangeToShipping(v)}
                        isChecked={isAutoChangeToShipping}
                    />
                  </div>
                  <div className={`flex justify-between mt-2`}>
                    <div className={`text-sm font-medium`}>"На отгрузке" на "В доставке"</div>
                    <ToggleButton
                        name={index + "isAutoChangeToDelivery"}
                        toggleHandler={(v) => setIsAutoChangeToDelivery(v)}
                        isChecked={isAutoChangeToDelivery}
                    />
                  </div>
                </div>
              </div>

              <div className="mt-4 flex justify-between">
                <div className={"w-4/12"}>

                </div>

                <button
                    className="self-end items-center text-sm text-left font-medium mb-1 border-[1px] px-[15px] h-[42px] rounded mt-2 active:outline-none"
                    onClick={() => {
                      updateDataHandler(index, null)
                    }}
                    type={"button"}
                >
                  Удалить правило
                </button>

              </div>

            </div>
        )}
      </div>
  );
};
